import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";

export default function UpdatePopUp({ list, setPopUp, callback, url, flage }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    ajeer_location_eng: "",
    ajeer_location_ar: "",
  });
  console.log("popup log to be printed in console",list)
  const token = localStorage.getItem("nodeToken");
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await nodeinstance.post(
        url,
        flage === true
          ? list.map((t) => ({
              employee_id: t.employee_id,
              ajeer_location_eng: formData.ajeer_location_eng,
              ajeer_location_ar: formData.ajeer_location_ar,
            }))
          : list.map((t) => ({
              employee_id: t.employee_id,
              ajeer_location_eng: formData.ajeer_location_eng,
              ajeer_location_ar: formData.ajeer_location_ar,
              ajeer_expiry_date: t.ajeer_expiry_date,
              ajeer_fees: t.ajeer_fees,
            })),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status == true) {
        setPopUp(false);
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        callback();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold"> Update Ajeer Location</h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={submitHandler}
            className="w-full flex flex-col my-4 gap-3"
          >
            <div className="flex flex-col gap-1">
              <label className="text-sm">Location English</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                defaultValue={formData?.name?.toUpperCase()}
                required
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    ajeer_location_eng: e.target.value,
                  })
                }
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm">Location Arabic</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                required
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    ajeer_location_ar: e.target.value,
                  })
                }
              />
            </div>

            <div className="flex  gap-3 mx-auto my-3 w-full px-5">
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
